import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface OrganizationStoreState {
  selectedOrganizationId: string | null;
  selectedOrganizationName: string | null;
  setOrganization: (id: string | null, name: string | null) => void;
  clearOrganization: () => void;
}

export const useOrganizationStore = create<OrganizationStoreState>()(
  persist(
    (set) => ({
      selectedOrganizationId: null,
      selectedOrganizationName: null,
      setOrganization: (id, name) =>
        set((state) => {
          if (
            state.selectedOrganizationId === id &&
            state.selectedOrganizationName === name
          ) {
            return state;
          }

          return {
            selectedOrganizationId: id,
            selectedOrganizationName: name,
          };
        }),
      clearOrganization: () =>
        set((state) => {
          if (
            state.selectedOrganizationId === null &&
            state.selectedOrganizationName === null
          ) {
            return state;
          }

          return {
            selectedOrganizationId: null,
            selectedOrganizationName: null,
          };
        })
    }),
    {
      name: 'organization-store',
      partialize: (state) => ({
        selectedOrganizationId: state.selectedOrganizationId,
        selectedOrganizationName: state.selectedOrganizationName,
      })
    }
  )
);

